var _path, _path2, _path3, _path4, _path5, _path6, _rect, _mask, _ellipse, _path7, _rect2, _g, _path8, _g2, _rect3, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWaitingConnectCheque(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 222,
    height: 120,
    viewBox: "0 0 222 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.8002 18.9302C70.0725 20.989 68.109 22.464 65.8011 22.464C63.4931 22.464 61.5296 20.989 60.8019 18.9302H58.7334V101.975H60.8019C61.5296 99.9166 63.4931 98.4415 65.8011 98.4415C68.109 98.4415 70.0725 99.9166 70.8002 101.975H78.4711C79.1988 99.9166 81.1622 98.4415 83.4702 98.4415C85.7782 98.4415 87.7417 99.9166 88.4693 101.975H96.1402C96.8679 99.9166 98.8314 98.4415 101.139 98.4415C103.447 98.4415 105.411 99.9166 106.138 101.975H108.207V18.9302H106.138C105.411 20.989 103.447 22.464 101.139 22.464C98.8314 22.464 96.8679 20.989 96.1402 18.9302H88.4693C87.7417 20.989 85.7782 22.464 83.4702 22.464C81.1622 22.464 79.1988 20.989 78.4711 18.9302H70.8002Z",
    fill: "white",
    stroke: "#C7C7CC",
    strokeWidth: 1.4896
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75.3396 33.21L92.3047 33.21",
    stroke: "#C7C7CC",
    strokeWidth: 1.4896,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M75.3396 90.0867L92.3047 90.0867",
    stroke: "#C7C7CC",
    strokeWidth: 1.4896,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6924 49.9802L100.953 49.9802",
    stroke: "#C7C7CC",
    strokeWidth: 1.4896,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6924 61.7073L100.953 61.7073",
    stroke: "#C7C7CC",
    strokeWidth: 1.4896,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6924 73.7275L100.953 73.7275",
    stroke: "#C7C7CC",
    strokeWidth: 1.4896,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.445146,
    y: 0.954619,
    width: 45.0708,
    height: 79.0325,
    rx: 5.21359,
    transform: "matrix(0.939692 0.342021 -0.342019 0.939693 121.633 14.7913)",
    fill: "white",
    stroke: "#254E5F",
    strokeWidth: 1.4896
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-8-inside-1_14236_73296",
    fill: "white"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.16401,
    cy: 1.16138,
    rx: 1.16401,
    ry: 1.16138,
    transform: "matrix(0.939692 0.342021 -0.342019 0.939693 135.633 24.2302)"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.16401,
    cy: 1.16138,
    rx: 1.16401,
    ry: 1.16138,
    transform: "matrix(0.939692 0.342021 -0.342019 0.939693 135.633 24.2302)",
    fill: "#254E5F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M136.023 25.6083C136.087 25.435 136.276 25.3508 136.442 25.4113L135.423 28.2108C136.797 28.7109 138.321 28.0061 138.823 26.6273L136.023 25.6083ZM136.442 25.4113C136.608 25.4717 136.698 25.6577 136.635 25.831L133.836 24.8121C133.334 26.1909 134.049 27.7106 135.423 28.2108L136.442 25.4113ZM136.635 25.831C136.572 26.0044 136.383 26.0885 136.217 26.0281L137.236 23.2286C135.862 22.7284 134.338 23.4333 133.836 24.8121L136.635 25.831ZM136.217 26.0281C136.051 25.9677 135.96 25.7816 136.023 25.6083L138.823 26.6273C139.325 25.2485 138.61 23.7287 137.236 23.2286L136.217 26.0281Z",
    fill: "#254E5F",
    mask: "url(#path-8-inside-1_14236_73296)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.347062,
    y: 0.744276,
    width: 8.15071,
    height: 1.16138,
    rx: 0.580689,
    transform: "matrix(0.939692 0.342021 -0.342019 0.939693 139.555 25.4836)",
    fill: "#254E5F",
    stroke: "#254E5F",
    strokeWidth: 1.16138
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_14236_73296)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.10403,
    cy: 3.09701,
    rx: 3.10403,
    ry: 3.09701,
    transform: "matrix(0.939692 0.342021 -0.342019 0.939693 115.479 89.8135)",
    fill: "white"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M119.554 94.5923C119.11 95.8115 117.758 96.4419 116.533 95.9957C115.307 95.5495 114.676 94.1977 115.12 92.9784C115.564 91.7592 116.916 91.1288 118.142 91.575C119.367 92.0212 119.998 93.373 119.554 94.5923Z",
    stroke: "#254E5F",
    strokeWidth: 1.4896
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_14236_73296)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40.773,
    height: 61.7686,
    rx: 2.97919,
    transform: "matrix(0.939692 0.342021 -0.34202 0.939693 120.866 24.6897)",
    fill: "#F8F8F8"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.445146,
    y: 0.954618,
    width: 39.2834,
    height: 60.279,
    rx: 2.2344,
    transform: "matrix(0.939692 0.342021 -0.34202 0.939693 121.22 24.595)",
    stroke: "#254E5F",
    strokeWidth: 1.4896
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14236_73296)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 129.212,
    cy: 60.7868,
    r: 10.5588,
    transform: "rotate(20 129.212 60.7868)",
    fill: "#DCAE1D",
    stroke: "#DCAE1D",
    strokeWidth: 1.74766,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.33 54.9707L129.213 60.7872L131.172 64.988",
    stroke: "white",
    strokeWidth: 1.74766,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_14236_73296",
    x: 114.233,
    y: 90.6868,
    width: 6.20801,
    height: 8.19727,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_14236_73296"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_14236_73296",
    x: 100.578,
    y: 25.5281,
    width: 57.7637,
    height: 71.0566,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.744799
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.4896
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_14236_73296"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14236_73296"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.3022,
    height: 23.3022,
    fill: "white",
    transform: "translate(122.249 45.8535) rotate(20)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaitingConnectCheque);
export default __webpack_public_path__ + "static/media/waiting_connect_cheque.a72c437e7ef7952ffc1891d18fc5ce76.svg";
export { ForwardRef as ReactComponent };